__webpack_require__.p = "https://frontends.udemycdn.com/frontends-graphql-devhub/_next/";